import { render, staticRenderFns } from "./HomeAppBand.vue?vue&type=template&id=28e6480c&scoped=true"
import script from "./HomeAppBand.vue?vue&type=script&lang=js"
export * from "./HomeAppBand.vue?vue&type=script&lang=js"
import style0 from "./HomeAppBand.vue?vue&type=style&index=0&id=28e6480c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e6480c",
  null
  
)

export default component.exports